var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("Please wait... We are preparing the dashboard")])
}
var staticRenderFns = []

export { render, staticRenderFns }